import React, { useState, useEffect } from 'react';
import { IoEarth, IoNewspaperSharp } from 'react-icons/io5';
import { FaDownload } from 'react-icons/fa';

import './index.css';

const Journals = () => {
    const URL = `${process.env.PUBLIC_URL}/_data/tnd/datasets.json`;

    const [content, setContent] = useState([]);

    useEffect(() => {
        // GET QuickLinks
        fetch(URL)
            .then((res) => res.json())
            .then((reply) => {
                setContent(reply);
            });
    }, []);

    return (
        <div id="Datasets" className="datasets">
            <h3>Datasets</h3>
            <ol>
                {content.map((item, index) => {
                    return (
                        <li key={index}>
                            <h5>
                                <a className="tool-title" target="blank" href={item.link}>
                                    {item.name}
                                </a>
                            </h5>
                            <p className="dataset-desc">{item.description}</p>
                            {item.website && item.website.length > 0 ? (
                                <a className="tool-link" href={item.website} target="blank">
                                    <IoEarth />
                                </a>
                            ) : (
                                ''
                            )}
                            {item.paper && item.paper.length > 0 ? (
                                <a className="tool-link" href={item.paper} target="blank">
                                    <IoNewspaperSharp />
                                </a>
                            ) : (
                                ''
                            )}
                            {item.download && item.download.length > 0 ? (
                                <a className="tool-link" href={item.download} target="blank">
                                    <FaDownload />
                                </a>
                            ) : (
                                ''
                            )}
                        </li>
                    );
                })}
            </ol>
        </div>
    );
};

export default Journals;
